import React from 'react'

function Words() {
  return (
    <div>Words</div>
  )
}

export default Words